import React from 'react'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

interface CharterRoundConfigProps {
  gate: boolean
  onChange: (patch: { charter_gate_enabled?: boolean }) => void
  disabled?: boolean
}

/**
 * Round 0 (Pre-Game Charter) settings — rendered inside the rounds configuration
 * area (only when charter is enabled). The enable toggle lives above the rounds
 * configuration; this holds the gate + read-only manual phases. Uses the same
 * row styling as the game-round phase settings for visual consistency.
 */
export const CharterRoundConfig: React.FC<CharterRoundConfigProps> = ({
  gate,
  onChange,
  disabled = false,
}) => {
  return (
    <div className='space-y-4'>
      <h4 className='font-medium text-md'>
        Round 0 Settings (Pre-Game Charter)
      </h4>

      {/* Gate toggle */}
      <div className='grid grid-cols-[1fr_auto] items-center gap-4 bg-slate-50 p-4 rounded-md'>
        <div>
          <Label htmlFor='charter-gate'>Charter Gate</Label>
          <p className='mt-0.5 text-sm text-gray-500'>
            Prevent the game from starting until all teams have ratified their
            charter.
          </p>
        </div>
        <Switch
          id='charter-gate'
          checked={gate}
          onCheckedChange={(checked) =>
            onChange({ charter_gate_enabled: checked })
          }
          disabled={disabled}
        />
      </div>

      {/* Read-only phases — mirror the phase-duration rows but timer-less */}
      <div className='grid grid-cols-[1fr_auto_200px_80px] items-center gap-4 bg-slate-50 p-4 rounded-md'>
        <Label>Phase 1 — Individual Preparation</Label>
        <span />
        <span className='text-sm text-gray-500'>Manual — no timer</span>
        <span className='text-gray-500'>∞</span>
      </div>
      <div className='grid grid-cols-[1fr_auto_200px_80px] items-center gap-4 bg-slate-50 p-4 rounded-md'>
        <Label>Phase 2 — Group Charter</Label>
        <span />
        <span className='text-sm text-gray-500'>Manual — no timer</span>
        <span className='text-gray-500'>∞</span>
      </div>

      <p className='text-sm italic text-gray-500'>
        Phase progression is controlled manually from the Timer Controls tab
        (Start / End Phase / Previous Phase).
      </p>
    </div>
  )
}
